import { FC } from "react";
import { useTranslation } from "react-i18next";

import { TableHeadCell } from "@digital-services/ui";
import { SortQueryDirection } from "@ds-cps/ui";

interface Props {
  activeSort: string;
  sortDirection: SortQueryDirection | undefined;
  handleSort: (sortName: string) => void;
}

export const OrganizationsHeaderRow: FC<Props> = (props: Props) => {
  const { activeSort, sortDirection, handleSort } = props;

  const nameColumnName = "name";
  const externalId = "external-id";
  const countryColumnName = "country";
  const typeColumnName = "type";
  const statusColumnName = "status";
  const createdOnColumnName = "created-on";

  const { t: tOrganization } = useTranslation(undefined, {
    keyPrefix: "organization"
  });

  function handleSortHeaderClick(columnName: string) {
    handleSort(columnName);
  }

  function renderSortableTableHeadCell(columnName: string) {
    return (
      <TableHeadCell
        sortActive={activeSort === columnName}
        sortDirection={sortDirection}
        onSort={() => handleSortHeaderClick(columnName)}
        data-testid={`${columnName}-column`}
      >
        <span>{tOrganization(`${columnName}.column-header`)}</span>
      </TableHeadCell>
    );
  }

  return (
    <thead className="[&>tr>th]:sticky [&>tr>th]:top-0 [&>tr>th]:bg-white">
      <tr className="leading-[0px]">
        {renderSortableTableHeadCell(nameColumnName)}
        {renderSortableTableHeadCell(externalId)}
        {renderSortableTableHeadCell(countryColumnName)}
        {renderSortableTableHeadCell(typeColumnName)}
        {renderSortableTableHeadCell(statusColumnName)}
        {renderSortableTableHeadCell(createdOnColumnName)}
      </tr>
    </thead>
  );
};
